module.exports = __webpack_public_path__ + "img/product-units.7be0962d.svg";